import React, { type ReactNode } from 'react';

import { Inline } from '@atlaskit/primitives/compiled';

export type SessionLastUpdatedProps = {
	lastUpdated: ReactNode;
	testId?: string;
};

/** Renders display-ready localized relative session time. */
export const SessionLastUpdated = ({
	lastUpdated,
	testId,
}: SessionLastUpdatedProps): React.JSX.Element | null => {
	if (lastUpdated === undefined || lastUpdated === null || lastUpdated === false) {
		return null;
	}

	return (
		<Inline as="span" shouldWrap={false} testId={testId}>
			{lastUpdated}
		</Inline>
	);
};
